import type { ReactNode } from 'react';
import { Chip } from './Chip';
import type { LedgerStatus } from '../api';

export type PillKind = 'paid' | 'due' | 'over';

/** PillKind is the ledger's vocabulary; Chip's is the design system's. */
const TONE = { paid: 'paid', due: 'due', over: 'overdue' } as const;

/**
 * Ledger status pill. Kept as its own export because six screens import it by
 * name; it is now a thin call into the shared Chip rather than a second
 * implementation. Status colours remain fixed: paid green / due amber /
 * overdue red.
 */
export function Pill({ kind, children }: { kind: PillKind; children: ReactNode }) {
  return (
    <Chip tone={TONE[kind]} size="md" dot>
      {children}
    </Chip>
  );
}

/** Map a ledger status to a pill kind + label. */
export function statusPill(status: LedgerStatus | undefined): { kind: PillKind; label: string } {
  switch (status) {
    case 'paid':
      return { kind: 'paid', label: 'Paid' };
    case 'overdue':
      return { kind: 'over', label: 'Overdue' };
    case 'partial':
      return { kind: 'over', label: 'Partial' };
    case 'waived':
      return { kind: 'paid', label: 'Waived' };
    case 'due':
    default:
      return { kind: 'due', label: 'Due' };
  }
}
